
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  height:100%;
  max-width:100%;
}

:host [variation='large'] .container{
    height:100%;
  }

.container{
  background-color:var(--brand-white);
  box-shadow:0px 4px 40px 5px rgba(4, 30, 74, 0.1);
  height:100%;
}

.container.small{
    display:flex;
    margin-bottom:var(--spacing-12);
  }

.content{
  display:flex;
  flex-direction:column;
  padding:var(--spacing-7);
}

.content.small{
    padding-block:var(--spacing-6);
    flex:5;
    justify-content:center;
  }

.rule{
  border:solid var(--brand-green-900);
  border-width:8px 0 0;
  height:1px;
  padding:0;
  position:relative;
  text-align:left;
  width:100%;
  margin:var(--spacing-6) 0;
  border-radius:3px;
  border-top-width:3px;
}

.contact-info{
  margin-bottom:var(--spacing-6);
}

.employment-info{
  margin-bottom:var(--spacing-6);
}

div[slot='name'] a{
  transition:background-color 0.425s, border-color 0.425s;
}

div[slot='name'] a:hover,
  div[slot='name'] a:focus{
    background-color:var(--brand-green-900);
  }

div[slot='name'] a:focus{
    background-color:var(--brand-green-900);
    border-top-color:var(--brand-dark-blue-900);
    outline:none;
  }

div[slot='title'],
div[slot='department']{
  text-transform:uppercase;
}

div[slot='email']{
  word-wrap:break-word;
}

div[slot='phone'],
div[slot='email']{
  color:var(--brand-dark-blue-900);
  font-size:var(--fs-headline-2xs-responsive);
  line-height:1.5;
}

div[slot='phone'] a, div[slot='email'] a{
    padding:0 0.1875rem;
    border-bottom:2px solid var(--brand-dark-blue-900);
    border-top:2px solid transparent;
    transition:background-color 0.425s, border-color 0.425s;
  }

div[slot='phone'] a:hover,
    div[slot='phone'] a:focus,
    div[slot='email'] a:hover,
    div[slot='email'] a:focus{
      background-color:var(--brand-green-900);
    }

div[slot='phone'] a:focus, div[slot='email'] a:focus{
      background-color:var(--brand-green-900);
      border-top-color:var(--brand-dark-blue-900);
      outline:none;
    }

.btn{
  width:100%;
  justify-content:center;
}

@media (min-width: 768px){

.btn{
    width:auto;
    justify-content:flex-start
}
  }

.image{
  height:312px;
  display:flex;
  background-color:var(--brand-gray-200);
}

.small .image{
    height:auto;
    flex:2;
    min-width:12rem;
  }

div[slot='image']{
  width:100%;
  height:100%;
  overflow:hidden;
}

div[slot='image'] .contextual-region{
    height:100%;
  }

img{
  width:100%;
  height:100%;
  vertical-align:middle;
  object-fit:cover;
  object-position:center;
}
`;